import * as React from "react";
import { Autocomplete, TextField, Button } from "@mui/material";
import { useSchoolContext } from "../../contexts/ProviderProvider";

const SingleSchoolSelector = ({ setSelectedSchool, selectedSchool, allButton }) => {
    const [schoolInput, setSchoolInput] = React.useState("");
    const { schools } = useSchoolContext();

    const schoolNames = schools.map((school) => school.schoolName);

    const handleAddSchool = (schoolName) => {
        setSelectedSchool(schoolName);
    };

    return (
        <Autocomplete
            value={selectedSchool || null}
            onChange={(event, newValue) => {
                handleAddSchool(newValue);
            }}
            inputValue={schoolInput}
            onInputChange={(event, newInputValue) => {
                setSchoolInput(newInputValue);
            }}
            options={schoolNames}
            getOptionLabel={(option) => option || ""}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="School List"
                    variant="outlined"
                    fullWidth
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: allButton ? (
                            <>
                                <Button
                                    disabled={selectedSchool === "All"}
                                    variant="contained"
                                    size="small"
                                    onClick={() => {
                                        setSchoolInput("All");
                                        handleAddSchool("All");
                                    }}
                                    style={{ marginRight: 8 }}
                                >
                                    ALL
                                </Button>
                                {params.InputProps.endAdornment}
                            </>
                        ) : params.InputProps.endAdornment,
                    }}
                />
            )}
        />
    );
};

export default SingleSchoolSelector;
